import request from '@/utils/request'

// 获取轮播图
export function getBanner(params) {
  return request({
    url: '/system/findAll',
    method: 'get',
    params
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/biz-user/findCurrentUserInfo',
    method: 'get'
  })
}

// 获取用户信息
export function getWmsList() {
  return request({
    url: '/system/findLogisticsType',
    method: 'get'
  })
}

// 获取收货地址
export function getAddrList() {
  return request({
    url: '/biz-user/findAddressList',
    method: 'get'
  })
}

// 编辑收货地址
export function editAddress(params) {
  return request({
    url: '/biz-user/updateById',
    method: 'post',
    data: params
  })
}

// 新增收货地址
export function addAddress(params) {
  return request({
    url: '/biz-user/insert',
    method: 'post',
    data: params
  })
}

// 获取收货地址
export function delAddress(params) {
  return request({
    url: '/biz-user/deleteById',
    method: 'delete',
    params
  })
}

// 设置默认地址
export function setDefaultAddr(params) {
  return request({
    url: '/biz-user/setDefaultAddressById',
    method: 'get',
    params
  })
}

// 设置默认地址
export function getDefaultAddr() {
  return request({
    url: '/biz-user/getDefaultAddress',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/system.js